// RUM scopes a feature flag evaluation to one view, and this app starts views
// manually, so every startView drops what was already reported. Hold the
// evaluations here and replay them each time a view begins.
const evaluations = new Map<string, string>();

// The map outlives a single test, so tests reset it between cases.
export function clearReportedFeatureFlags() {
    evaluations.clear();
}

export function replayFeatureFlagsToRum() {
    evaluations.forEach((variant, flagName) => {
        window?.DD_RUM?.addFeatureFlagEvaluation?.(flagName, variant);
    });
}

export function reportFeatureFlagToRum(flagName: string, variant: string) {
    evaluations.set(flagName, variant);
    window?.DD_RUM?.addFeatureFlagEvaluation?.(flagName, variant);
}
